import { Placement } from "./Placement";
import { TILES } from "../helpers/tiles";
import Sprite from "../components/object-graphics/Sprite";
import { PLACEMENT_TYPE_HERO } from "../helpers/consts";

export class GoalTilePlacement extends Placement {
  isOnlyType() {
    return true;
  }

  completesLevelOnCollide(forBody) {
    return (
      forBody.type === PLACEMENT_TYPE_HERO &&
      this.level.areAllChipsCollected &&
      this.level.isPlayingMode
    );
  }

  renderComponent() {
    return (
      <Sprite
        frameCoord={
          this.level.areAllChipsCollected
            ? TILES.GOAL_ENABLED
            : TILES.GOAL_DISABLED
        }
      />
    );
  }
}
